import { HttpHandler } from 'msw'

import { createSaleReport } from './createSaleReport'
import { getAllSaleReports } from './getAllSaleReports'
import { getSaleReport } from './getSaleReport'

export const saleReports: HttpHandler[] = [
    createSaleReport,
    getAllSaleReports,
    getSaleReport,
]
